<template>
  <div id="Holding" style="overflow: hidden">
       <!-- Desktop Below -->
        <b-row class="showDesk">
            <b-col class="bkimage" lg="7" sm="6" v-bind:style="{ 'background-image': 'url(' + 'https://wp-ocssport.ocs-sport.com/thegrass/wp-content/uploads/sites/10/2025/10/GRASS_Background-scaled.jpg' + ')' }">
                <b-container>
                    <div class="leftSec">
                        <div class="grassSecImage">
                            <img class="grassImage" src="https://wp-ocssport.ocs-sport.com/thegrass/wp-content/uploads/sites/10/2025/10/Logo.png">
                        </div>
                        <div class="commingSoon">COMING SOON</div>
                        <h2 class="h2Class"><span class="firstLetter">G</span>olfs <span class="firstLetter">R</span>elevant <span class="firstLetter">A</span>dvanced <br> <span class="firstLetter">S</span>coring <span class="firstLetter">S</span>tatistics</h2>
                        <!-- <h2 class="h2Class">Golfs<br> Relevant<br> Advanced <br> Scoring <br> Statistics</h2> -->
                        <p class="pClass">Transforming Golf Performance Data for Tours, Players, and Fans</p>
                    </div>
                </b-container>
            </b-col>
            <b-col class="bkimageRight" lg="5" sm="6" v-bind:style="{ 'background-image': 'url(' + 'https://wp-ocssport.ocs-sport.com/thegrass/wp-content/uploads/sites/10/2025/10/bk.png' + ')' }">
            
            </b-col>
        </b-row>
        <!-- Mobile Below -->
        <b-row class="showMob">
            <b-col class="bkimage" sm="12" v-bind:style="{ 'background-image': 'url(' + 'https://wp-ocssport.ocs-sport.com/thegrass/wp-content/uploads/sites/10/2025/10/GRASS_Background-scaled.jpg' + ')' }">
                <b-container>
                    <div class="leftSec">
                        <div class="grassSecImage">
                            <img class="grassImage" src="https://wp-ocssport.ocs-sport.com/thegrass/wp-content/uploads/sites/10/2025/10/Logo.png">
                        </div>
                        <div class="commingSoon">COMING SOON</div>
                        <h2 class="h2Class"><span class="firstLetter">G</span>olfs <br> <span class="firstLetter">R</span>elevant <br><span class="firstLetter">A</span>dvanced <br> <span class="firstLetter">S</span>coring <br><span class="firstLetter">S</span>tatistics</h2>
                        <!-- <h2 class="h2Class">Golfs<br> Relevant<br> Advanced <br> Scoring <br> Statistics</h2> -->
                        <p class="pClass">Transforming Golf Performance Data for Tours, Players, and Fans</p>
                    </div>
                </b-container>
            </b-col>
            <b-col class="bkimageRight" sm="12" v-bind:style="{ 'background-image': 'url(' + 'https://wp-ocssport.ocs-sport.com/thegrass/wp-content/uploads/sites/10/2025/10/bk.png' + ')' }">
            
            </b-col>
        </b-row>
        <div id="grad1"></div>
  </div>
</template>

<script>


import axios from 'axios'
export default {
  name: 'Holding Page',
  components: {

  },
  data: function() {
    return {
      acf: [],
    };
  },
  methods: {
    // isMobile() {
    //     if( screen.width <= 768 ) {
    //         return true;
    //     }
    //     else {
    //         return false;
    //     }
    // },
  },
  mounted() {
    axios //add API Call
        .get(
           'https://wp-ocssport.ocs-sport.com/' + 'thegrass' + "/wp-json/wp/v2/pages/13" + '?randomadd=' +
          new Date().getTime()
        ) // Page number changed on each page based on JSON page id you are calling
        .then((response) => (
            this.acf = response.data
        )); //API data wanted pulled out
  },
}
</script>
<style scoped>
.firstLetter {
    /* color: linear-gradient(to right, #a2e3e8, #9dd58a); */
    color: #9dd58a;
}
.leftSec {
    padding: 100px;
    margin-top: 150px;
}
.grassSecImage {
    text-align: left;
}
.grassImage {
    /* width: 69px;
    height: 77px; */
}
.pClass {
    text-align: left;
    font-size: 23px;
    font-weight: 600;
    margin-top: 30px;
}
.h2Class {
    text-align: left;
    font-weight: 900;
    font-size: 60px;
    margin-top: 30px;
    line-height: 1;
}
.commingSoon {
    font-size: 20px;
    font-weight: 900;
    width: 200px;
    background-color: #a2e3e8;
    background-image: linear-gradient(to right, #a2e3e8, #9dd58a);
    height: 36px;
    line-height: 2;
    margin-top: 150px;
}
#Holding {
    overflow-y: hidden!important;
}
/* .HP {
    color: black;
    font-size: 20pt;
} */
.bkimage {
    height: 97vh;
    background-repeat: no-repeat;
}
.bkimageRight {
    height: 97vh;
    background-position: center;
    background-size: cover;
}
#grad1 {
  height: 45px;
  background-color: #a2e3e8; /* For browsers that do not support gradients */
  background-image: linear-gradient(to right, #a2e3e8 , #9dd58a);
}
@media only screen and (max-width: 1280px) {
    .h2Class {
        text-align: left;
        font-weight: bold;
        font-size: 50px;
        margin-top: 30px;
    }
}
@media only screen and (min-width: 1025px) {
     .showMob {
        display: none;
    }   
}
@media only screen and (max-width: 1024px) {
    .showDesk {
        display: none;
    }
    .h2Class {
        text-align: left;
        font-weight: bold;
        font-size: 50px;
        margin-top: 30px;
    }
    .leftSec {
        padding: 20px;
        margin-top: 100px;
    }
    .h2Class {
        text-align: left;
        font-weight: bold;
        font-size: 40px;
        margin-top: 30px;
    }
    .bkimage {
        height: auto;
        background-repeat: no-repeat;
    }
    .commingSoon {
        font-size: 20px;
        font-weight: 700;
        width: 200px;
        background-color: #a2e3e8;
        background-image: linear-gradient(90deg, #a2e3e8, #9dd58a);
        height: 36px;
        line-height: 2;
        margin-top: 80px;
    }
    .pClass {
        padding-bottom: 50px;
    }
}
</style>
